// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a9b4bd1e","239":"bde12879","453":"15357c2f","455":"94c32b2d"}[chunkId] + ".chunk.js";
};